{
  "en": {
    "proposal": {
      "actions": {
        "addDescription": "Add description",
        "addDocuments": "Add documents",
        "addSubchoiceList": "Add subchoice list",
        "addSubchoices": "Add subchoice",
        "approve": "Accept",
        "cancel": "Cancel",
        "choice": {
          "collapse": "Collapse choices",
          "delete": "Delete choice",
          "edit": "Edit choice",
          "expand": "Expand choices"
        },
        "choice_list": {
          "delete": "Delete choice list"
        },
        "createNew": "New proposal",
        "deleteDescription": "Delete description",
        "deleteDocuments": "Remove documents",
        "delete_documents": "Delete document | Delete documents",
        "delete_proposal": "Delete proposal",
        "delete_proposal_templates": "Delete proposal template",
        "dontShare": "No need to share yet",
        "duplicate": "Duplicate",
        "edit": "Edit",
        "generatePDF": "Generate PDF",
        "new": "Proposal",
        "newProposalCustomer": "New proposal",
        "publish": "Publish",
        "reject": "Undo approval",
        "save": "Save",
        "share": "Share",
        "shareWithProjectPartners": "Share documents with Project Partners...",
        "share_units": "Share with units",
        "signAndApprove": "Sign and approve proposal",
        "signElectronically": "Or sign electronically instead",
        "steps": {
          "collapse": "Collapse steps",
          "expand": "Expand steps"
        },
        "stop_template_sync": "Stop sync with template",
        "submit": "Submit",
        "uploadAndApprove": "Upload and approve proposal",
        "uploadSignableDocument": "Upload signed document for approval"
      },
      "attributes": {
        "amount_gross": "Gross Offer",
        "amount_net": "Net Offer",
        "choice_lists": {
          "description": "Description",
          "name": "Name"
        },
        "choices": {
          "description": "Description",
          "images": "Images",
          "name": "Name",
          "price_gross": "Item price gross",
          "price_net": "Item price net",
          "quantity": "Quantity",
          "quantity_fixed": "Fixed quantity",
          "quantity_max": "Maximum",
          "quantity_min": "Minimum",
          "quantity_not_fixed": "Let customer fill in quantity",
          "selected_default": "Always selected",
          "total_price_gross": "Total gross",
          "total_price_net": "Total net"
        },
        "description": "How would you describe this proposal?",
        "documents": "Add documents",
        "name": "Name",
        "subtitle": "This makes it easy for others to refer to",
        "title": "Give your proposal a title",
        "type": {
          "choices": "Choice list",
          "fixed": "Fixed offer"
        },
        "vat_percentage": "VAT %"
      },
      "labels": {
        "accepted": "Accepted",
        "addExtraBudget": "Add extra budget",
        "already_approved": "This proposal has already been approved.",
        "amount_net_total": "Total net offer",
        "amount_total": "Total gross offer",
        "approve": "Approve {name}",
        "approved": "Approved",
        "approvedDate": "Approved {date}",
        "ask_client_to_undo": "You cannot edit an approved proposal. Please contact {client} to undo the approval first.",
        "batchProposalsTemplate": "<p>This proposal will be created for {units_count} unit(s).</p></br><p>Because this proposal will be created for multiple units, we've made a template out of it. You can find this template under the 'Proposal templates' tab.</p></br><p>Templates make it easier to edit or delete all proposals that are shared with this template.</p>",
        "batchProposalsWarning": "This proposal will be created for {units_count} units. If you need to make any changes to it later, you'll need to edit each one separately.",
        "budget": "Budget",
        "builder": {
          "can_select_multiple": "Can select multiple",
          "item": "Add choice",
          "multiple_choices_possible": "Multiple choices possible",
          "must_choose_item": "Must choose choice",
          "options": "Choices",
          "section": "Choice list",
          "step": "Step",
          "step_basic": "Basic information",
          "step_details": "Details",
          "step_documents": "Documents",
          "step_internal": "Internal information",
          "step_visibility": "Share with"
        },
        "by": "by",
        "choice_lists": {
          "add_another": "Add another choice list",
          "create": "Create proposal choice lists",
          "empty_help": "Start by adding your first choice list(s). Choice lists group choices for a specific item, e.g. \"floor tiles\". After you've added choice lists, you can add one or more choices.",
          "selected": "Selected"
        },
        "choices": {
          "add_another": "Add another choice",
          "create": "Add choices to {choiceListName}",
          "optional": "optional",
          "selected_default": "This choice will always be selected and the price will automatically be calculated in the total price. The customer will not be able to deselect this choice.",
          "selected_default_tooltip": "This choice is always included and its price is automatically calculated in the total.",
          "subtotal": "Subtotal"
        },
        "clickToChangeVisibility": "Click to change visibility",
        "closed": "This decision is now closed. You can not approve a proposal anymore.",
        "createProposal": "Create proposal",
        "createProposals": "Create proposal",
        "createdBy": "Created by {uploader}",
        "customer": "Customer",
        "customerHasNotSelectedYet": "Customer has not selected yet",
        "customer_name_confirm": "Write <i><b>{customerName}</b></i> in order to accept this proposal.",
        "customer_name_proceed": "Please type <i><b>{customerName}</b></i> to proceed.",
        "customer_offer": "Customer offer",
        "customers": "Customers",
        "decision_not_interested": "The decision is marked as not interested.",
        "definedPerUnit": "Defined per unit",
        "delete_proposal_template": "<p>If you delete this template, all synced proposals will also be deleted.<br>If you don't want this to happen, use the switch below.</p>",
        "depends_on_customer_input": "Depends on customer input",
        "documentsRequireSignature": "Customer needs to sign documents",
        "documents_shared_partners": "Only documents of the proposal are shared with project partners.",
        "duplicating": "Duplicating",
        "edit": "Edit",
        "editNotAllowed": "Editing or deleting an approved proposal is not allowed. Please undo the approval first before editing.",
        "editProposal": "Edit Proposal",
        "excl%VAT": "excl. {vat}% VAT",
        "exclVAT": "excl. VAT",
        "export_documents": "Export documents",
        "extraBudget": "Extra budget",
        "fractions_sent_count_header": "Can't create proposal!",
        "fractions_sent_count_message": "Installments based on this decision have already been sent. Please change these installments to draft first to continue.",
        "full_prices": "Use full prices. Ziggu will automatically generate upgrades based on the decisions budget",
        "generatingPDF": "Generating PDF",
        "has_requested_changes": "This proposal already has a change request pending.",
        "hideDetails": "Hide details",
        "installments_connected": "There are installments connected to this proposal.",
        "internalNote": "Internal note",
        "internalNoteSubtitle": "This note is only visible to you and your team.",
        "internal_info": "Internal information",
        "keepHidden": "Keep hidden",
        "keep_synced_proposals": "Keep synced proposals so they become a standalone proposal.",
        "link_to_template": "Link to template?",
        "link_to_template_after_create": "Immediately link this proposal to the new template after creation.",
        "makeDecision": "Accept a proposal for {decision_name} by clicking the approve button",
        "margin": "Margin",
        "marginBudget%": "Margin budget ({margin}%)",
        "marginSurcharge%": "Margin upgrades ({margin}%)",
        "marginSurchargesExtraBudget%": "Margin extra budget + upgrades ({margin}%)",
        "new": "New proposal",
        "noImage": "No image",
        "no_budget_available_yet": "Not applicable",
        "no_documents": "Proposal does not contain any documents.",
        "no_edit_details": "This proposal has elements depending on it. Contact the client if you want to edit details",
        "no_edit_details_installments": "This proposal has at least one invoiced or paid installment. To edit the proposal details, you must first change the status of this installment to 'Expected'. Go to {link}.",
        "no_edit_details_installments_link": "financials",
        "no_edit_documents": "When a proposal is approved, documents can not be edited.",
        "notApplicable": "Not applicable",
        "notDefined": "Not defined",
        "notSeenYetByCustomer": "Not yet seen by the customer",
        "notSelectedYet": "Select your choices to see the total",
        "notSharedYet": "Not shared yet",
        "not_approved_yet": "This proposal is not yet approved.",
        "not_interested_reset_header": "Decision marked as not interested",
        "not_interested_reset_message": "This decision is currently marked as 'Not interested'. Creating a proposal will reset the 'Not interested' status.",
        "only_visible_team_partners": "Only visible for the team",
        "other": "Other",
        "proposalFor": "Proposal for",
        "proposal_template_sync_note": "Making changes to a proposal template updates all synced (unapproved) proposals.",
        "proposal_unapprove_not_possible": "Cannot undo approval",
        "proposalsApproved": "Approved proposals",
        "proposalsOther": "Other proposals",
        "relaunch": "Relaunch proposal",
        "request_changes": {
          "body": "Please provide some additional feedback as to what needs to be changed in this proposal",
          "feedback": "Feedback",
          "title": "Request changes"
        },
        "requested_changes": "Changes requested",
        "requiresSignature": "Needs to sign documents",
        "seenByCustomer": "Seen by customer:",
        "selectUnitsShare": "Select units to share template with",
        "shareCustomerDescription": "This proposal is linked to a decision that hasn't been shared yet with the customer. Do you want to share the decision too so the customer can see this proposal immediately?",
        "shareCustomerTitle": "Share decision with customer?",
        "shareDecision": "Share decision",
        "shareExtraAlert": "The decision will be shared too once you click send",
        "sharePartnerTitle": "Share decision with partner?",
        "sharePartnersDescription": "This proposal is linked to a decision that hasn't been shared yet with the partner. Do you want to share the decision too so the partner can see this proposal immediately?",
        "sharedWith": "Shared with",
        "showAndEditDetails": "Show and edit details",
        "single_approval_warning": {
          "message": "Contact Ziggu to enable multiple proposal approvals.",
          "title": "You can continue creating proposals, but the customer can only approve one proposal."
        },
        "skip_customer": "The project skips the customer step.",
        "surcharges": "Upgrades",
        "surcharges_extra": "Extra upgrades",
        "synced_with_template": "Synced with proposal template",
        "synced_with_units": "Synced with 1 unit | Synced with {unit_count} units",
        "template_accept_confirm": "<p>This proposal is synced with a proposal template. When you accept this proposal,the synchronization will stop and this proposal will no longer be updated when the proposal template gets updated.</p></br><p>Are you sure you want to accept this proposal?</p>",
        "template_edit_confirm": "<p>This proposal is synced with a proposal template. When you edit this proposal, the synchronization will stop and this proposal will no longer be updated when the proposal template gets updated.</p></br><p>Are you sure you want to continue editing this proposal?</p>",
        "totalBudget": "Total budget",
        "totalNetOffer": "Net offer",
        "total_excl_vat": "Total excl. VAT",
        "total_incl_vat": "Total incl. VAT",
        "total_vat": "Total VAT",
        "typeToShare": "Type of proposal to share",
        "unit_not_activated": "The unit is not activated.",
        "uploadDocuments": "Upload signed documents",
        "uploadSignedDocument": "Or upload signed document instead",
        "vat_excl": "excl. VAT",
        "vat_excl_with_number": "excl. {vat} VAT%",
        "visibleForCustomer": "Visible for the customer",
        "writeEmployeeNameAccept": "Write <i><b>{employeeName}</b></i> in order to accept this proposal.",
        "writeEmployeeNameDelete": "Write <i><b>{employeeName}</b></i> in order to remove this proposal.",
        "writeEmployeeNameReject": "Write <i><b>{employeeName}</b></i> in order to undo the approval for this proposal."
      },
      "placeholders": {
        "customers": {
          "none": {
            "subtitle": "Soon you'll find a proposal here to approve",
            "title": "No proposals for decision {decision_name} yet"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Propose one or more offers and let your customer decide.",
            "title": "Create a proposal"
          },
          "proposalNotice": "Important: only 1 proposal can be approved. You can always edit an existing proposal and add new documents.",
          "template": {
            "subtitle": "When you create proposals in bulk, they will show up here",
            "title": "No proposal templates have been created yet."
          }
        },
        "partners": {
          "new": {
            "subtitle": "Propose one or more offers and let the customer decide.",
            "title": "Create a proposal"
          },
          "proposalNotice": "Important: only 1 proposal can be approved. You can always edit an existing proposal and add new documents. If a proposal has been approved already, a team member can undo it before adding extra documents."
        }
      },
      "toasts": {
        "convert": "Proposal successfully converted into template",
        "create": "Proposal successfully created",
        "delete": "Proposal successfully deleted",
        "shareSuccess": "Proposals successfully shared",
        "update": "Proposal successfully updated"
      },
      "validation": {
        "amountNotUpdatable": "Amount cannot be updated: some installments depends on it",
        "choice_list": {
          "needChoice": "This choice list needs at least 1 choice",
          "needSelection": "This choice requires a selected item"
        },
        "choices": {
          "lessThanOrEqual": "Number has to be less than or equal to {max_number}",
          "needPriceItem": "Price per item is required",
          "needSelection": "Choice selection required",
          "needVatPercentage": "Vat percentage is required",
          "quantityBetween": "Quantity must be between {quantity_min} and {quantity_max}",
          "quantityNotZero": "Quantity needs to be at least 1",
          "quantityRequired": "Quantity is required",
          "uniqueNames": "Names must be unique"
        },
        "nameNotCorrect": "Name is required and needs to match",
        "needName": "Title is required",
        "needNumber": "Must be a number (e.g. 85)",
        "need_request_changes_note": "Please give feedback regarding your change request",
        "readAllDocuments": "Make sure you have read all documents",
        "requiresSignature": "Mark at least 1 document where the customer needs to sign electronically. Turn off the toggle below if you don't need signatures.",
        "share": {
          "needSelection": "Select someone to share the proposal with | Select someone to share the proposals with",
          "needType": "Select the type(s) of proposal"
        },
        "uploadAtLeast1Document": "Upload at least 1 signed document"
      }
    }
  }
}
